import React, { ReactNode } from 'react';

type SectionActionProps = {
    className?: string;
    children: ReactNode;
};

const SectionAction = ({ className = '', children }: SectionActionProps) => {
    return (
        <div className={`mb-12 ${className}`}>
            {children}
        </div>
    );
};

export default SectionAction;
